import styled from 'styled-components'

export const Root = styled.div`
  color: ${props => props.theme.palette.gray[20]};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 14px;
  line-height: 18px;
  margin: ${props => props.margin};
  padding: ${props => props.padding};
`
